"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var theme_1 = require("../theme");

exports.Table = styled_components_1.default.table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  border-spacing: 0;\n  text-align: left;\n  border-radius: 2px;\n  thead {\n    background: ", ";\n  }\n  tbody {\n    background: ", ";\n    tr.divider {\n      height: 12px;\n      td {\n        background: ", ";\n        opacity: 0.5;\n        height: 100%;\n        width: 100%;\n        font-weight: 500;\n      }\n    }\n  }\n  th,\n  td {\n    border: 1px solid ", ";\n  }\n  th {\n    border-bottom: 1px solid ", ";\n  }\n  p {\n    margin: 0;\n  }\n  ", "\n  ", "\n  tr.success > td:first-of-type {\n    border-left: 4px solid ", ";\n    margin-left: -4px;\n  }\n  tr.warning > td:first-of-type {\n    border-left: 4px solid ", ";\n    margin-left: -4px;\n  }\n  tr.critical > td:first-of-type {\n    border-left: 4px solid ", ";\n    margin-left: -4px;\n  }\n"])), function (props) {
  return props.width || "100%";
}, theme_1.theme.colors.white[700], theme_1.theme.colors.white[900], theme_1.theme.colors.white[700], theme_1.theme.colors.white[500], theme_1.theme.colors.white[300], function (props) {
  if (props.space === "tight") {
    console.warn("DEPRECATED: Table > props.space");
    return (0, styled_components_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        p {\n          font-size: 0.8em;\n        }\n        th,\n        td {\n          padding: 0.2em 0.6em;\n        }\n      "])));
  }

  if (props.size === "sm") {
    return (0, styled_components_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        th {\n          font-size: 13px;\n        }\n        td {\n          font-size: 12px;\n          & > input {\n            font-size: initial;\n          }\n        }\n        th,\n        td {\n          padding: 0.3em 0.5em;\n        }\n      "])));
  }

  if (props.size === "xs") {
    return (0, styled_components_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        th {\n          font-size: 12px;\n        }\n        td {\n          font-size: 11px;\n          & > input {\n            font-size: initial;\n          }\n        }\n        th,\n        td {\n          padding: 0.2em 0.4em;\n        }\n      "])));
  }

  return (0, styled_components_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      p {\n        font-size: 0.9em;\n      }\n      th,\n      td {\n        padding: 0.5em 0.8em;\n      }\n    "])));
}, function (props) {
  if (props.hoverHighlight) {
    return (0, styled_components_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        tbody > tr:hover {\n          cursor: pointer;\n          color: ", ";\n          transition: 150ms;\n        }\n      "])), theme_1.theme.colors.brand[500]);
  }
}, theme_1.theme.colors.green[500], theme_1.theme.colors.orange[500], theme_1.theme.colors.red[500]);